// NGRX
import { Store, select } from '@ngrx/store';
// CRUD
import { BaseDataSource, QueryResultsModel } from '../../_base/crud';
// State
import { AppState } from '../../reducers';
import {
  selectLinksInStore,
  selectLinksPageLoading,
  selectLinksShowInitWaitingMessage,
} from '../_selectors/link.selectors';

export class LinksDataSource extends BaseDataSource {
  constructor(private store: Store<AppState>) {
    super();

    this.loading$ = this.store.pipe(select(selectLinksPageLoading));

    this.isPreloadTextViewed$ = this.store.pipe(select(selectLinksShowInitWaitingMessage));

    this.store.pipe(select(selectLinksInStore)).subscribe((response: QueryResultsModel) => {
      this.paginatorTotalSubject.next(response.totalCount);
      this.entitySubject.next(response.items);
    });
  }
}
